<template>
  <div>
    <vx-card>
      <ListOriginSystem />
    </vx-card>
  </div>
</template>
<script>
import ListOriginSystem from '@/views/menu/configuracoes/origin-system/components/ListOriginSystem.vue';

export default {
  name: 'SystemOrigin',
  components: { ListOriginSystem },
  data() {
    return {};
  },
  methods: {},
};
</script>
